// React
import { memo, useCallback, useEffect, useState } from "react";

// Servisni sloj
import { getFleetVehicleInvoiceAPI, sendFleetVehicleInvoiceSaleEmailAPI } from "services/api/fleet/vehicles/invoices/api";
import { transformFleetDocumentUploadToFileExtended } from "services/api/fleet/vehicles/offers/transformations";
import { InvoiceOutgoing } from "services/api/fleet/vehicles/invoices/types";

// UI
import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import { EmailSendModal } from "ui/components/Modal/EmailSendModal";
import { EmailSendData } from "ui/components/Modal/EmailSendModal/types";

import { InvoiceEmailModalProps } from "./types";

/**
 * Slanje računa kupcu e-mailom. PDF računa se dohvaća sa servera i nudi kao privitak,
 * a uspješno slanje prebacuje račun u status "Poslan".
 */
const InvoiceEmailModal: React.FC<InvoiceEmailModalProps> = (props) => {
  const { show, onHide, formValues, onSent } = props;

  const [pdfAttachment, setPdfAttachment] = useState<FileExtended | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPdfAttachment = useCallback(async () => {
    if (!formValues.id) return;

    setIsLoading(true);

    try {
      const result: InvoiceOutgoing = await getFleetVehicleInvoiceAPI(formValues.id);

      if (result.pdfUpload) {
        setPdfAttachment(transformFleetDocumentUploadToFileExtended(result.pdfUpload));
      }
    } catch {
      // greška se prikazuje kroz snackbar
    }

    setIsLoading(false);
  }, [formValues.id]);

  useEffect(() => {
    if (!show) return;

    setPdfAttachment(null);
    fetchPdfAttachment();
  }, [show, fetchPdfAttachment]);

  const handleSend = useCallback(async (data: EmailSendData) => {
    const result = await sendFleetVehicleInvoiceSaleEmailAPI(formValues.id!, data);

    if (result.sent) {
      onSent(result);
    }

    return result.sent;
  }, [formValues.id, onSent]);

  return (
    <EmailSendModal
      show={show}
      onHide={onHide}
      title={`Slanje putem e-maila [Račun ${formValues.invoiceNumber ?? ""}]`}
      initialFormValues={{
        subject: `Račun ${formValues.invoiceNumber ?? ""}`,
        content: `Poštovani,\n\nu privitku e-maila šaljemo Račun za plaćanje.\n\nLijep pozdrav`,
        pdfAttachment: pdfAttachment,
      }}
      contactId={formValues.contactClientId ?? undefined}
      onSend={handleSend}
      isLoading={isLoading}
    />
  );
};

export default memo(InvoiceEmailModal);
